module.exports = __webpack_public_path__ + "static/img/7.71b7296.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/7/zh/7.png
// module id = nCIV
// module chunks = 0